import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth, profileAPI } from "services";
import { Loader } from "components";
import useUniversalStore from "store/universalStore";
import EmailVerify from "./EmailVerify";
import { toast } from "sonner";

function Profile() {
  const { profile, user, write } = useUniversalStore((state) => state);
  const navigate = useNavigate();

  const initialValues = {
    phone: "",
    businessName: "",
    typeOfBusiness: "",
    email: "",
    loading: false
  }

  const [values, setValues] = useState(initialValues);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    setValues((prev) => ({
      ...prev,
      phone: profile?.get("phone") || user?.get("username"),
      businessName: profile?.get("businessName") || "",
      typeOfBusiness: profile?.get("typeOfBusiness") || "",
      email: user?.get("email") || "",
    }));
  }, [profile, user]);

  const saveProfile = async (e) => {
    e.preventDefault();

    setIsEditing(true);
    setValues((prev) => ({ ...prev, loading: true }));

    try {
      //Update Profile with new values
      const result = await profileAPI.updateProfile(values);
      const updateUser = await auth.updateEmail(values.email);

      //Update Global State
      write({
        profile: result,
        user: updateUser
      });

      toast.success("Profile updated successfully!");
    } catch (error) {
      toast.error("Failed to update profile");
    } finally {
      //Reset Edit Mode
      setIsEditing(false);
      setValues((prev) => ({ ...prev, loading: false }));
    }
  }

  const updateField = (field, value) => {
    setValues((prev) => ({ ...prev, [field]: value }));
  }

  return (
    <div className="container">
      <div className="row mt-3 mt-md-5">
        <div className="col-2 col-md-1">
          <a role="button" className="btn btn-app"
            onClick={() => navigate(-1)}
            title="Back">
            <i className="bi bi-arrow-left"></i>
          </a>
        </div>
        <div className="col-10 col-md-11">
          <h1 className="">Profile Details</h1>
        </div>
      </div>
      <hr />
      <div className="row">
        <table className="table">
          <tbody className="mb-4">
            <tr>
              <th scope="row" className="fw-bold fs-5 py-3">Phone</th>
              <td>
                <input
                  className="form-control"
                  type="tel"
                  value={values.phone || ""}
                  onChange={(e) => updateField("phone", e.target.value)}
                  disabled
                />
              </td>
            </tr>
            <tr>
              <th scope="row" className="fw-bold fs-5 py-3">Business Name</th>
              <td>
                <input
                  className="form-control"
                  type="text"
                  onChange={(e) => updateField("businessName", e.target.value)}
                  value={values.businessName || ""}
                  disabled={!isEditing}
                />
              </td>
            </tr>
            <tr>
              <th scope="row" className="fw-bold fs-5 py-3">Type of Business</th>
              <td>
                <select id="typeOfBusiness"
                  className="form-select"
                  defaultValue={values.typeOfBusiness || ""}
                  disabled={!isEditing}
                  onChange={(e) => updateField("typeOfBusiness", e.target.value)}>
                  <option value="service">Services</option>
                  <option value="manufacturing">Manufacturing</option>
                  <option value="trading">Trading</option>
                </select>
              </td>
            </tr>
            <tr>
              <th scope="row" className="fw-bold fs-5 py-3">Email</th>
              <td colSpan="2" className="position-relative">
                <input className="form-control"
                  type="email"
                  value={values.email || ""}
                  onChange={(e) => updateField("email", e.target.value)}
                  disabled={!isEditing} />
                <EmailVerify />
              </td>
            </tr>
          </tbody>
        </table>
        <div className="col-12">
          <button
            className="btn btn-app py-3 mb-5 w-100 d-flex justify-content-center align-items-center"
            disabled={values.loading}
            onClick={isEditing ? saveProfile : () => setIsEditing(true)}>
            <span className="fs-5 me-2">{isEditing ? 'Save Profile' : 'Edit Profile'}</span>
            {values.loading && <Loader />}
          </button>
        </div>
      </div>

    </div>
  )
}
export default Profile;
